// Data for the Coursera Hiring Solutions roles that have search data with keywords generated from Chat GPT
// to improve search relevancy in the occupation preferences select field

const courseraHiringSolutionsRolesSearchData = [
  {
    label: 'Application Developer / Engineer',
    value: 'application-developer-engineer',
    searchText: 'application developer engineer software programming',
  },
  {
    label: 'Bookkeeper / Accounting Clerk',
    value: 'bookkeeper-accounting-clerk',
    searchText: 'bookkeeper accounting clerk finance',
  },
  {
    label: 'Career Counselor',
    value: 'career-counselor',
    searchText: 'career counselor guidance coach',
  },
  {
    label: 'Computer Support Specialist',
    value: 'computer-support-specialist',
    searchText: 'computer support specialist IT technician',
  },
  {
    label: 'Customer Service Representative',
    value: 'customer-service-representative',
    searchText: 'customer service representative support',
  },
  {
    label: 'Cyber Security Analyst',
    value: 'cyber-security-analyst',
    searchText: 'cyber security analyst information protection data software',
  },
  {
    label: 'Data Analyst',
    value: 'data-analyst',
    searchText: 'data analyst analysis statistics',
  },
  {
    label: 'Data Engineer',
    value: 'data-engineer',
    searchText: 'data engineer big data ETL',
  },
  {
    label: 'Data Scientist',
    value: 'data-scientist',
    searchText: 'data scientist machine learning AI',
  },
  {
    label: 'Data Warehouse Developer',
    value: 'data-warehouse-developer',
    searchText: 'data warehouse developer ETL SQL',
  },
  {
    label: 'Devops Engineer',
    value: 'devops-engineer',
    searchText: 'devops engineer infrastructure CI/CD',
  },
  {
    label: 'Digital Marketing Specialist',
    value: 'digital-marketing-specialist',
    searchText: 'digital marketing specialist SEO SEM',
  },
  {
    label: 'Front End Developer',
    value: 'front-end-developer',
    searchText: 'front end developer HTML CSS JavaScript software engineer programming',
  },
  {
    label: 'Human Resources Specialist',
    value: 'human-resources-specialist',
    searchText: 'human resources specialist HR recruitment',
  },
  {
    label: 'iOS Developer / Engineer',
    value: 'ios-developer-engineer',
    searchText: 'iOS developer engineer Swift Objective-C programming software',
  },
  {
    label: 'IT Project Manager',
    value: 'it-project-manager',
    searchText: 'IT project manager Agile Scrum',
  },
  {
    label: 'Mainframe Developer',
    value: 'mainframe-developer',
    searchText: 'mainframe developer COBOL DB2 software programming',
  },
  {
    label: 'Marketing Analyst',
    value: 'marketing-analyst',
    searchText: 'marketing analyst research strategy',
  },
  {
    label: 'Network Engineer / Architect',
    value: 'network-engineer-architect',
    searchText: 'network engineer architect Cisco Juniper',
  },
  {
    label: 'Project Manager',
    value: 'project-manager',
    searchText: 'project manager PMP leadership',
  },
  {
    label: 'Sales Development Representative',
    value: 'sales-development-representative',
    searchText: 'sales development representative SDR outbound',
  },
  {
    label: 'Sales Operations Specialist',
    value: 'sales-operations-specialist',
    searchText: 'sales operations specialist CRM analysis',
  },
  {
    label: 'Sales Representative',
    value: 'sales-representative',
    searchText: 'sales representative quota B2B',
  },
  {
    label: 'Social Media Strategist / Specialist',
    value: 'social-media-strategist-specialist',
    searchText: 'social media strategist specialist content',
  },
  {
    label: 'Solutions / Application Architect',
    value: 'solutions-application-architect',
    searchText: 'solutions application architect design',
  },
  {
    label: 'Technology Consultant',
    value: 'technology-consultant',
    searchText: 'technology consultant IT advisory',
  },
  {
    label: 'User Experience (UX) Designer',
    value: 'user-experience-ux-designer',
    searchText: 'user experience UX designer UI',
  },
  {
    label: 'Software Developer / Engineer',
    value: 'software-developer-engineer',
    searchText: 'software developer engineer programming languages',
  },
];

export default courseraHiringSolutionsRolesSearchData;
